module.exports = __webpack_public_path__ + "media/images/ic_diner-2d0bd378478b0c7b230319be35a3dfad.svg";